import React from 'react'
import { Form as FinalForm } from 'react-final-form'

import { RailsForm } from '@support/RailsForm'
import Form from './Form'

export const FieldNotebookConfiguration = ({ model, o }) =>
  <RailsForm
    component={FinalForm}
    action='patch'
    url={`/v4/o/${o}/admin/organizations/${model.organization_id}/products/${model.id}/field_notebook`}
    successUrl={`/v4/o/${o}/admin/organizations/${model.organization_id}/products`}
    initialValues={model.metadata}
    render={(props) => (
      <Form
        {...props}
        organization_id={model.organization_id}
        title={I18n.t('v4/field_notebook.config.title')}
        o={o}
      />
    )}
  />

FieldNotebookConfiguration.defaultProps = {
  model: {
    metadata: {}
  }
}

export default FieldNotebookConfiguration
